import { LetsStartCard } from '../../components/lets-start-card'
import { AuthLayout } from '../../components/auth-layout'

export const letsStartPage = () => {
  return (
    <AuthLayout showTerms={false}>
      <LetsStartCard />
    </AuthLayout>
  )
}